import AbstractCanopyStyle from "./AbstractCanopyStyle";

export default class LobedCanopyStyle extends AbstractCanopyStyle {
    generatePoints() {
        let r = this.ellipse.absSize / 2;
        // absSize is 0 while a plant is being placed. Floor the count so the
        // loop always makes a closed curve instead of an empty array.
        let numPoints = Math.max(Math.floor(this.ellipse.absSize), 8);
        let noiseScale = 3;
        let amplitude = 0.11;
        let points = [];

        for (let i = 0; i < numPoints; i++) {
            let angle = (i / numPoints) * this.p.TWO_PI;
            // Sample 2D noise along a circle for seamless looping
            let nx = this.p.cos(angle) * noiseScale + noiseScale;
            let ny = this.p.sin(angle) * noiseScale + noiseScale;
            let noise = this.p.noise(nx, ny);
            let radius = r * (1 + amplitude * (noise * 2 - 1));
            points.push({
                dx: radius * this.p.cos(angle),
                dy: radius * this.p.sin(angle),
            });
        }
        return points;
    }

    display(g, opacity) {
        this.ensurePoints();
        let pts = this._points;
        let n = pts.length;
        if (n < 2) return;
        let scale = this.view.scale;
        let absX = this.ellipse.absX;
        let absY = this.ellipse.absY;

        g.beginShape();
        // Wrap last point as leading control point
        g.curveVertex((absX + pts[n - 1].dx) * scale, (absY + pts[n - 1].dy) * scale);
        for (let pt of pts) {
            g.curveVertex((absX + pt.dx) * scale, (absY + pt.dy) * scale);
        }
        // Wrap first two points to close the curve smoothly
        g.curveVertex((absX + pts[0].dx) * scale, (absY + pts[0].dy) * scale);
        g.curveVertex((absX + pts[1].dx) * scale, (absY + pts[1].dy) * scale);
        g.endShape();
    }

    getMiniView(size) {
        this.ensurePoints();
        let r = this.ellipse.absSize / 2;
        return this._points.map(pt => [
            this.p.map(pt.dx, -r, r, 20 - size / 2, 20 + size / 2),
            this.p.map(pt.dy, -r, r, 20 - size / 2, 20 + size / 2),
        ]);
    }
}
